import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VariavelStruct } from '@shared/services/structs/formula/variavel.struct';
import { FormulaExpressaoToken, tokenizarExpressaoFormula } from '../utils/formula-expressao.util';
import { classeBadgeFuncao, classeBadgeTokenFormula, classeBadgeVariavel, isVariavelParametro } from '../utils/formula-badge.util';
import { FormulaTokenTipoEnum } from '@shared/enums/formula/formula-token-tipo.enum';
import { ExpressaoBadge } from './expressao-badge';
import { mapearBlocosFuncao, obterBlocoFuncaoEstrutural } from '../utils/formula-funcao-bloco';

@Component({
    selector: 'app-formula-expressao-section',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './formula-expressao-section.component.html',
    styleUrl: './formula-expressao-section.component.css',
})
export class FormulaExpressaoSectionComponent implements OnChanges {
    public readonly FormulaTokenTipoEnum = FormulaTokenTipoEnum;
    @Input({ required: true }) expressao = '';
    @Input() variaveis: VariavelStruct[] = [];

    public itens: ExpressaoBadge[] = [];

    ngOnChanges(): void {
        const tokens = tokenizarExpressaoFormula(this.expressao);
        const blocos = mapearBlocosFuncao(tokens);
        this.itens = tokens.map((token, index) => {
            if (token.tipo !== FormulaTokenTipoEnum.Variavel) {
                const blocoFuncao = obterBlocoFuncaoEstrutural(blocos, index);
                return {
                    token,
                    badgeClass: blocoFuncao
                        ? classeBadgeFuncao(blocoFuncao.nome, blocoFuncao.nivel)
                        : classeBadgeTokenFormula(token),
                    nome: token.display,
                    codigo: '',
                    nomeVariavel: '',
                    chave: '',
                    isParametro: false,
                    possuiFormulaAplicavel: false,
                };
            }

            const tag = token.valor.slice(1, -1);
            const variavel = this.variaveis.find(v => this.variavelChave(v) === tag);
            return {
                token,
                badgeClass: classeBadgeVariavel(variavel),
                nome: variavel?.descricao ?? tag,
                codigo: `{${tag}}`,
                nomeVariavel: variavel?.nome ?? tag,
                chave: tag,
                isParametro: isVariavelParametro(variavel),
                possuiFormulaAplicavel: variavel?.possuiFormulaAplicavel === true,
            };
        });
    }

    private variavelChave(variavel: VariavelStruct): string {
        return variavel.chave || variavel.tagXml || variavel.nome;
    }
}
